(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpine-build-your-truck"] && !Shopify.designMode) return;
  try {
    
(() => {
  const CACHE_PREFIX = 'alpine.fitment.catalog.v4:';
  const CACHE_TTL = 30 * 60 * 1000;
  const previewId = () => new URL(location.href).searchParams.get('preview_theme_id') || 'live';
  const cacheKey = () => CACHE_PREFIX + previewId();

  const init = section => {
    if (!section || section.dataset.builderReady === 'true') return;
    section.dataset.builderReady = 'true';

    const endpoint = section.dataset.endpoint;
    const loadStatus = section.querySelector('[data-load-status]');
    const panel = section.querySelector('[data-builder-panel]');
    const packagePanel = section.querySelector('[data-package]');
    const vehicleStatus = section.querySelector('[data-vehicle-status]');
    const vehicleLabel = section.querySelector('[data-vehicle-label]');
    const total = section.querySelector('[data-total]');
    const addButton = section.querySelector('[data-add-package]');
    const cartStatus = section.querySelector('[data-cart-status]');
    const fields = [
      section.querySelector('[data-year]'),
      section.querySelector('[data-make]'),
      section.querySelector('[data-model]'),
      section.querySelector('[data-engine]')
    ];
    const fieldKeys = ['year','make','model','engine'];
    const parts = [...section.querySelectorAll('[data-part]')];
    const vehicleParts = parts.filter(part => part.dataset.part !== 'tip');
    const tipPart = section.querySelector('[data-part="tip"]');
    const tipFeed = section.querySelector('[data-tip-feed]');
    let tipProducts = [];
    try { tipProducts = JSON.parse(tipFeed?.textContent || '[]'); } catch (_) {}

    const sotfFeed = section.querySelector('[data-sotf-feed]');
    let sotfProducts = [];
    try { sotfProducts = JSON.parse(sotfFeed?.textContent || '[]'); } catch (_) {}
    const tuningPart = section.querySelector('[data-part="tuning"]');
    const tuningAccessories = tuningPart?.querySelector('[data-tuning-accessories]');
    const sotfSwitch = tuningPart?.querySelector('[data-sotf-switch]');
    const sotfHarness = tuningPart?.querySelector('[data-sotf-harness]');
    const sotfHarnessWrap = tuningPart?.querySelector('[data-sotf-harness-wrap]');
    const sotfMount = tuningPart?.querySelector('[data-sotf-mount]');
    const sotfMountWrap = tuningPart?.querySelector('[data-sotf-mount-wrap]');
    const sotfHelp = tuningPart?.querySelector('[data-sotf-help]');

    let products = [];
    let apps = [];
    let familyMakes = [];
    let family = '';

    const TUNING_FORM_URL = 'https://form.jotform.com/260044807308049';
    const safe = value => typeof value === 'string' ? value : '';
    const validApp = app => app && Number.isInteger(app.from) && Number.isInteger(app.to) &&
      app.from >= 1900 && app.to <= 2100 && app.from <= app.to &&
      ['make','model','engine'].every(key => safe(app[key]));

    const selection = () => Object.fromEntries(fields.map((field,i) => [fieldKeys[i],field.value]));
    const matches = (app,car,upto=4) => Number(car.year) >= app.from && Number(car.year) <= app.to &&
      (upto < 2 || app.make === car.make) && (upto < 3 || app.model === car.model) && (upto < 4 || app.engine === car.engine);

    const isSwitchableTune = text => /(\bSOTF\b|\bCSP[- ]?\d*\b|\bDSP\b|switch on the fly|\b5\s*tunes?\b|\b5[- ]tune\b)/i.test(String(text||''));
    const platform = text => {
      const value=String(text||'').toLowerCase();
      if(value.includes('commander')) return 'commander';
      if(value.includes('sct')) return 'sct';
      if(value.includes('ez lynk')||value.includes('ezlynk')) return 'ezlynk';
      if(value.includes('efi live')||value.includes('efilive')) return 'efilive';
      if(value.includes('mpvi3')||value.includes('hp tuner')) return 'mpvi3';
      if(value.includes('mm3')) return 'mm3';
      return '';
    };
    const platformCompatible=(tuneText,accessoryText)=>{
      const tp=platform(tuneText); if(!tp) return true;
      const a=String(accessoryText||'').toLowerCase();
      const explicit=[];
      if(a.includes('commander')) explicit.push('commander');
      if(a.includes('sct')) explicit.push('sct');
      if(a.includes('ez lynk')||a.includes('ezlynk')) explicit.push('ezlynk');
      if(a.includes('efi live')||a.includes('efilive')) explicit.push('efilive');
      if(a.includes('mpvi3')||a.includes('hp tuner')) explicit.push('mpvi3');
      if(a.includes('mm3')) explicit.push('mm3');
      if(!explicit.length||explicit.includes(tp)) return true;
      if(tp==='mpvi3'&&(explicit.includes('efilive')||a.includes('csp'))) return true;
      if(tp==='efilive'&&(explicit.includes('mpvi3')||a.includes('csp'))) return true;
      if(tp==='mm3'&&a.includes('csp')) return true;
      return false;
    };
    const appOverlap=(a,b)=>Number(a?.from)<=Number(b?.to)&&Number(b?.from)<=Number(a?.to)&&
      String(a?.make||'')===String(b?.make||'')&&String(a?.model||'')===String(b?.model||'')&&String(a?.engine||'')===String(b?.engine||'');

    const money = cents => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA',{style:'currency',currency:'CAD'})
          .format((Number(cents)||0)/100);
      } catch (_) {
        return '$' + ((Number(cents)||0)/100).toFixed(2);
      }
    };

    const optionize = (field, values, placeholder) => {
      field.replaceChildren(new Option(placeholder,''));
      values.forEach(value => field.add(new Option(String(value),String(value))));
      field.disabled = !values.length;
      field.value = '';
    };

    const productGroup = product => {
      const category = safe(product.category).toLowerCase();
      const title = safe(product.title).toLowerCase();
      const source = (category + ' ' + title).trim();
      if (source.includes('exhaust')) return 'exhaust';
      if (source.includes('tuning') || source.includes('tune')) return 'tuning';
      if (source.includes('egr') || source.includes('ccv') || source.includes('intake') || source.includes('access') ||
          source.includes('add-on') || source.includes('addon') || source.includes('engine')) return 'addons';
      return 'addons';
    };

    const sanitizeProducts = source => {
      const unique = new Map();
      (Array.isArray(source) ? source : []).forEach(product => {
        if (!product || !safe(product.id) || !safe(product.title) || !Array.isArray(product.applications)) return;
        const applications = product.applications.filter(validApp);
        if (!applications.length) return;
        unique.set(String(product.id),{
          ...product,
          id:String(product.id),
          applications,
          variants:Array.isArray(product.variants) ? product.variants : []
        });
      });
      return [...unique.values()];
    };

    const readCatalogCache = () => {
      try {
        const raw = localStorage.getItem(cacheKey());
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || data.version !== 4 || !Number.isFinite(data.savedAt) || Date.now() - data.savedAt > CACHE_TTL) return null;
        const cachedProducts = sanitizeProducts(data.products);
        return cachedProducts.length ? cachedProducts : null;
      } catch (_) {
        return null;
      }
    };

    const writeCatalogCache = cachedProducts => {
      try {
        localStorage.setItem(cacheKey(),JSON.stringify({version:4,savedAt:Date.now(),products:cachedProducts}));
      } catch (_) {}
    };

    const setCatalog = productList => {
      products = sanitizeProducts(productList);
      apps = products.flatMap(product => product.applications);
      loadStatus.textContent = apps.length
        ? 'Choose Cummins, Powerstroke or Duramax to start building.'
        : 'Vehicle-mapped package parts are being added.';
      section.querySelectorAll('[data-family]').forEach(button=>button.disabled=!apps.length);
    };

    const productById = id => products.find(product => String(product.id) === String(id));
    const tipProductById = id => tipProducts.find(product => String(product.id) === String(id));

    const sizeFromText = value => {
      const match = String(value||'').match(/(?:^|[\s/(])([45])\s*[-]?\s*(?:"|”|″|inch(?:es)?\b|in\.?\b)/i);
      return match ? match[1] : '';
    };

    function selectedVariant(part) {
      if (!part) return null;

      if (part.dataset.part === 'tip') {
        const id = part.querySelector('[data-tip-choice]')?.value;
        if (!id) return null;
        for (const product of tipProducts) {
          const variant = (product.variants||[]).find(item=>String(item.id)===String(id));
          if (variant) return variant;
        }
        return null;
      }

      const product = productById(part.querySelector('[data-product]')?.value);
      if (!product) return null;
      const id = part.querySelector('[data-variant]')?.value;
      return (product.variants||[]).find(variant=>String(variant.id)===String(id)) || null;
    }

    const exhaustSize = () => {
      const exhaustPart = section.querySelector('[data-part="exhaust"]');
      const product = productById(exhaustPart?.querySelector('[data-product]')?.value);
      const variant = selectedVariant(exhaustPart);
      if (!product) return '';
      const sources = [...(variant?.options||[]),variant?.title||'',product.title||''];
      for (const source of sources) {
        const size = sizeFromText(source);
        if (size) return size;
      }
      return '';
    };

    const tipVariantsForSize = (product,size) => (product?.variants||[]).filter(variant =>
      variant.available && sizeFromText([...(variant.options||[]),variant.title||''].join(' '))===size
    );

    async function page(number) {
      const url = new URL(endpoint, location.origin);
      url.searchParams.set('view','alpine-fitment');
      url.searchParams.set('page',String(number));
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);

      const request = new AbortController();
      const timeout = setTimeout(()=>request.abort(),12000);
      try {
        const response = await fetch(url,{signal:request.signal,credentials:'same-origin',headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Vehicle data could not be loaded.');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const node = doc.querySelector('script[data-alpine-fitment-feed]');
        if (!node) throw new Error('Vehicle data is unavailable.');
        const data = JSON.parse(node.textContent);
        if (data.version !== 1 || !Number.isInteger(data.pages) || data.pages < 1 || data.pages > 100 ||
            data.page !== number || !Array.isArray(data.products)) throw new Error('Invalid vehicle data.');
        return data;
      } finally {
        clearTimeout(timeout);
      }
    }

    async function load() {
      try {
        const cached = readCatalogCache();
        if (cached) {
          setCatalog(cached);
          return;
        }

        const first = await page(1);
        const pages = [first];
        let nextPage = 2;
        const worker = async () => {
          while (nextPage <= first.pages) {
            const n = nextPage++;
            pages.push(await page(n));
          }
        };
        await Promise.all(Array.from({length:Math.min(4,Math.max(0,first.pages-1))},worker));
        const loadedProducts = sanitizeProducts(pages.flatMap(pg=>pg.products||[]));
        writeCatalogCache(loadedProducts);
        setCatalog(loadedProducts);
      } catch (error) {
        loadStatus.textContent = 'Package builder could not load. Use Shop by Vehicle below.';
      }
    }

    function familyYears() {
      const years = new Set();
      const currentYear = new Date().getFullYear();
      apps.filter(app=>familyMakes.includes(app.make)).forEach(app=>{
        const end = Math.min(app.to,currentYear);
        for (let year=app.from; year<=end; year++) years.add(year);
      });
      return [...years].sort((a,b)=>b-a);
    }

    function populate(index) {
      const car = selection();
      if (index===0) return optionize(fields[0],familyYears(),'Year');
      const key = fieldKeys[index];
      const pool = apps.filter(app=>familyMakes.includes(app.make) && matches(app,car,index));
      const values = [...new Set(pool.map(app=>app[key]))].sort((a,b)=>String(a).localeCompare(String(b)));
      optionize(fields[index],values,key[0].toUpperCase()+key.slice(1));
    }

    function clearParts() {
      parts.forEach(part=>{
        const preview = part.querySelector('[data-preview]');

        if (part.dataset.part === 'tip') {
          const tipChoice = part.querySelector('[data-tip-choice]');
          if (tipChoice) {
            tipChoice.replaceChildren(new Option('Select exhaust first',''));
            tipChoice.disabled = true;
          }
          if (preview) preview.replaceChildren(Object.assign(document.createElement('span'),{textContent:'Select exhaust first'}));
          const help = part.querySelector('[data-tip-help]');
          if (help) help.textContent = 'Choose a 4" or 5" exhaust first. Matching tips will appear automatically.';
          return;
        }

        const productSelect = part.querySelector('[data-product]');
        const variantSelect = part.querySelector('[data-variant]');
        const variantWrap = part.querySelector('[data-variant-wrap]');
        if (variantWrap) variantWrap.hidden = true;

        const placeholder = part.dataset.part === 'tuning' ? 'Skip tuning' :
          part.dataset.part === 'exhaust' ? 'Skip exhaust' : 'Skip EGR / add-on';
        if (productSelect) {
          productSelect.replaceChildren(new Option(placeholder,''));
          productSelect.disabled = false;
        }
        if (variantSelect) {
          variantSelect.replaceChildren(new Option('Choose options',''));
          variantSelect.disabled = true;
        }
        if (preview) preview.replaceChildren(Object.assign(document.createElement('span'),{textContent:'Optional'}));
      });

      resetTuningAccessories();
      total.textContent = money(0);
      addButton.disabled = true;
      cartStatus.textContent = '';
    }

    function resetTuningAccessories() {
      if (tuningAccessories) tuningAccessories.hidden = true;
      if (sotfSwitch) {
        sotfSwitch.replaceChildren(new Option('Select required switch',''));
        sotfSwitch.disabled = true;
      }
      if (sotfHarness) {
        sotfHarness.replaceChildren(new Option('No thanks',''));
        sotfHarness.disabled = true;
        sotfHarness.hidden = true;
      }
      if (sotfHarnessWrap) sotfHarnessWrap.hidden = true;
      if (sotfMount) {
        sotfMount.replaceChildren(new Option('No thanks',''));
        sotfMount.disabled = true;
        sotfMount.hidden = true;
      }
      if (sotfMountWrap) sotfMountWrap.hidden = true;
      if (sotfHelp) sotfHelp.textContent = '';
    }

    function accessoryChoices(kind,tuneProduct,tuneVariant) {
      const tuneText=(tuneProduct?.title||'')+' '+(tuneVariant?.title||'');
      const tuneApps=Array.isArray(tuneProduct?.applications)?tuneProduct.applications:[];
      const exact=[],fallback=[];
      const tunePlatform=platform(tuneText);

      sotfProducts.forEach(product=>{
        if(kind==='mount'&&product.kind!=='mount') return;
        if(kind==='harness'&&product.kind!=='harness') return;
        if(kind==='switch'&&product.kind!=='switch') return;

        (product.variants||[]).forEach(variant=>{
          const apps=(variant.applications||[]).length?variant.applications:(product.applications||[]);
          const descriptor=(product.title||'')+' '+(variant.title||'');
          const universal=!apps.length&&/\buniversal\b/i.test(descriptor)&&!/(powerstroke|duramax|cummins|ecodiesel|eco diesel|ford|ram|dodge|nissan|jeep|gm\b)/i.test(descriptor);
          const fit=universal||(apps.length&&tuneApps.some(t=>apps.some(a=>appOverlap(t,a))));
          if(!fit||!platformCompatible(tuneText,descriptor)) return;

          const item={
            id:String(variant.id),
            priceCents:Number(variant.priceCents)||0,
            label:product.title+(variant.title&&variant.title!=='Default Title'?' — '+variant.title:'')+' — '+variant.price,
            product,
            platformScore:platform(descriptor)===tunePlatform&&tunePlatform?0:1
          };
          (universal?fallback:exact).push(item);
        });
      });

      exact.sort((a,b)=>a.platformScore-b.platformScore||a.label.localeCompare(b.label));
      fallback.sort((a,b)=>a.label.localeCompare(b.label));
      return [...exact,...fallback];
    }

    function refreshTuningAccessories() {
      if(!tuningAccessories||!sotfSwitch) return;
      const tuneProduct=productById(tuningPart?.querySelector('[data-product]')?.value);
      const tuneVariant=selectedVariant(tuningPart);
      const text=(tuneProduct?.title||'')+' '+(tuneVariant?.title||'');

      resetTuningAccessories();
      if(!tuneProduct||!tuneVariant||!isSwitchableTune(text)) {
        updateTotal();
        return;
      }

      const switches=accessoryChoices('switch',tuneProduct,tuneVariant);
      const harnesses=accessoryChoices('harness',tuneProduct,tuneVariant);
      const mounts=accessoryChoices('mount',tuneProduct,tuneVariant);
      switches.forEach(x=>sotfSwitch.add(new Option(x.label,x.id)));
      harnesses.forEach(x=>sotfHarness?.add(new Option(x.label,x.id)));
      mounts.forEach(x=>sotfMount?.add(new Option(x.label,x.id)));

      tuningAccessories.hidden=false;
      sotfSwitch.disabled=!switches.length;
      if(switches.length===1) sotfSwitch.value=switches[0].id;

      if(sotfHarness&&sotfHarnessWrap){
        const show=harnesses.length>0;
        sotfHarness.hidden=!show;
        sotfHarnessWrap.hidden=!show;
        sotfHarness.disabled=!show;
      }
      if(sotfMount&&sotfMountWrap){
        const show=mounts.length>0;
        sotfMount.hidden=!show;
        sotfMountWrap.hidden=!show;
        sotfMount.disabled=!show;
      }
      if(sotfHelp) sotfHelp.textContent=switches.length
        ? 'Switchable tune selected. Choose the required switch. Matching harness/cable and bracket options are shown separately.'
        : 'Switchable tune selected. No exact switch is mapped; Alpine Diesel will confirm hardware after order.';
      updateTotal();
    }

    function resetAfter(index) {
      for (let i=index+1;i<4;i++) optionize(fields[i],[],fieldKeys[i][0].toUpperCase()+fieldKeys[i].slice(1));
      packagePanel.hidden = true;
      clearParts();
    }

    function exactProducts() {
      const car = selection();
      return products.filter(product=>product.applications.some(app=>matches(app,car)));
    }

    function fillPart(part,candidates) {
      const select = part.querySelector('[data-product]');
      const placeholder = part.dataset.part === 'tuning' ? 'Skip tuning' :
        part.dataset.part === 'exhaust' ? 'Skip exhaust' : 'Skip EGR / add-on';
      select.replaceChildren(new Option(placeholder,''));

      [...candidates]
        .sort((a,b)=>safe(a.title).localeCompare(safe(b.title)))
        .forEach(product=>{
          const option = new Option(product.title + (product.available ? '' : ' — unavailable'),String(product.id));
          option.disabled = !product.available;
          select.add(option);
        });

      select.disabled = false;
    }

    function showPackage() {
      const car = selection();
      if (!fields.every(field=>field.value)) return;

      const matched = exactProducts();
      const groups = {tuning:[],exhaust:[],addons:[]};
      matched.forEach(product=>groups[productGroup(product)].push(product));

      vehicleLabel.textContent = Object.values(car).join(' · ');
      vehicleStatus.textContent = matched.length
        ? groups.tuning.length + ' tuning · ' + groups.exhaust.length + ' exhaust · ' + groups.addons.length + ' EGR/add-on options found.'
        : 'No mapped package parts yet for this exact truck.';

      packagePanel.hidden = false;
      clearParts();
      vehicleParts.forEach(part=>fillPart(part,groups[part.dataset.part] || []));
      try { sessionStorage.setItem('alpine.vehicle.v1',JSON.stringify(car)); } catch (_) {}
    }

    function renderProduct(part) {
      const productSelect = part.querySelector('[data-product]');
      const variantSelect = part.querySelector('[data-variant]');
      const wrap = part.querySelector('[data-variant-wrap]');
      const preview = part.querySelector('[data-preview]');
      const product = productById(productSelect.value);

      variantSelect.replaceChildren(new Option('Choose options',''));
      variantSelect.disabled = true;
      wrap.hidden = true;
      preview.replaceChildren(Object.assign(document.createElement('span'),{textContent:'Optional'}));

      if (!product) {
        updateTotal();
        return;
      }

      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.loading = 'lazy';
        preview.replaceChildren(img);
      }

      const variants = (product.variants||[]).filter(variant=>variant.available);
      variants.forEach(variant=>{
        const title = variant.title && variant.title !== 'Default Title' ? variant.title : 'Standard';
        variantSelect.add(new Option(title + ' — ' + variant.price,String(variant.id)));
      });

      wrap.hidden = !variants.length;
      variantSelect.disabled = !variants.length;
      if (variants.length===1) variantSelect.value = String(variants[0].id);
      updateTotal();
    }

    function refreshTips() {
      if (!tipPart) return;

      const tipChoice = tipPart.querySelector('[data-tip-choice]');
      const preview = tipPart.querySelector('[data-preview]');
      const help = tipPart.querySelector('[data-tip-help]');
      const exhaustPart = section.querySelector('[data-part="exhaust"]');
      const exhaustProductId = exhaustPart?.querySelector('[data-product]')?.value || '';
      const size = exhaustSize();

      if (!tipChoice) return;

      tipChoice.replaceChildren();
      if (preview) preview.replaceChildren(Object.assign(document.createElement('span'),{textContent:'Optional'}));

      if (!exhaustProductId) {
        tipChoice.add(new Option('Select exhaust first',''));
        tipChoice.disabled = true;
        if (preview?.firstChild) preview.firstChild.textContent = 'Select exhaust first';
        if (help) help.textContent = 'Choose a 4" or 5" exhaust first. Matching tips will appear automatically.';
        updateTotal();
        return;
      }

      if (!size) {
        tipChoice.add(new Option('Choose exhaust size/options first',''));
        tipChoice.disabled = true;
        if (preview?.firstChild) preview.firstChild.textContent = 'Choose exhaust size first';
        if (help) help.textContent = 'Select the exhaust size/configuration first.';
        updateTotal();
        return;
      }

      const options=[];
      for (const product of tipProducts) {
        for (const variant of tipVariantsForSize(product,size)) {
          options.push({
            id:String(variant.id),
            label:product.title + ' — ' + variant.title + ' — ' + variant.price
          });
        }
      }

      tipChoice.add(new Option('No exhaust tip',''));
      options
        .sort((a,b)=>a.label.localeCompare(b.label))
        .forEach(option=>tipChoice.add(new Option(option.label,option.id)));

      tipChoice.disabled = options.length === 0;
      if (preview?.firstChild) preview.firstChild.textContent = size + '" exhaust selected';
      if (help) help.textContent = options.length
        ? 'Matching ' + size + '" inlet tips are shown below. Leave No exhaust tip if you do not want one.'
        : 'No matching ' + size + '" inlet tips are currently available.';
      updateTotal();
    }

    function updateTotal() {
      let cents = 0;
      let selectedCount = 0;
      let incomplete = false;

      parts.forEach(part=>{
        const productId = part.querySelector('[data-product]')?.value || '';
        const variant = selectedVariant(part);
        if (productId && !variant) incomplete = true;
        if (variant) {
          cents += Number(variant.priceCents) || 0;
          selectedCount++;
        }
      });

      const tuneProduct=productById(tuningPart?.querySelector('[data-product]')?.value);
      const tuneVariant=selectedVariant(tuningPart);
      const switchable=tuneProduct&&tuneVariant&&isSwitchableTune((tuneProduct.title||'')+' '+(tuneVariant.title||''));
      if(switchable&&sotfSwitch&&!sotfSwitch.disabled&&!sotfSwitch.value) incomplete=true;

      const accessoryById=id=>{
        for(const product of sotfProducts){
          for(const variant of product.variants||[]){
            if(String(variant.id)===String(id)) return variant;
          }
        }
        return null;
      };
      const switchVariant=accessoryById(sotfSwitch?.value);
      const harnessVariant=accessoryById(sotfHarness?.value);
      const mountVariant=accessoryById(sotfMount?.value);
      if(switchVariant){cents+=Number(switchVariant.priceCents)||0;selectedCount++;}
      if(harnessVariant){cents+=Number(harnessVariant.priceCents)||0;selectedCount++;}
      if(mountVariant){cents+=Number(mountVariant.priceCents)||0;selectedCount++;}

      total.textContent = money(cents);
      addButton.disabled = !selectedCount || incomplete;
      cartStatus.textContent = incomplete ? 'Choose the required options for each selected product.' : '';
    }

    section.querySelectorAll('[data-family]').forEach(button=>button.addEventListener('click',()=>{
      if (!apps.length) return;
      family = button.dataset.family || '';
      familyMakes = (button.dataset.makes||'').split('|').filter(Boolean);
      section.querySelectorAll('[data-family]').forEach(item=>item.setAttribute('aria-pressed',item===button?'true':'false'));
      panel.hidden = false;
      packagePanel.hidden = true;
      populate(0);
      for (let i=1;i<4;i++) optionize(fields[i],[],fieldKeys[i][0].toUpperCase()+fieldKeys[i].slice(1));
      vehicleStatus.textContent = family + ': choose your year.';
      panel.scrollIntoView({behavior:'smooth',block:'nearest'});
    }));

    fields.forEach((field,index)=>field.addEventListener('change',()=>{
      resetAfter(index);
      if (index<3 && field.value) populate(index+1);
      if (index===0 && fields[1].options.length===2) {
        fields[1].selectedIndex = 1;
        fields[1].dispatchEvent(new Event('change'));
      }
      if (index===2 && fields[3].options.length===2) {
        fields[3].selectedIndex = 1;
        fields[3].dispatchEvent(new Event('change'));
      }
      if (index===3 && field.value) showPackage();
    }));

    parts.forEach(part=>{
      if (part.dataset.part === 'tip') {
        part.querySelector('[data-tip-choice]')?.addEventListener('change',updateTotal);
        return;
      }

      part.querySelector('[data-product]')?.addEventListener('change',()=>{
        renderProduct(part);
        if (part.dataset.part === 'exhaust') refreshTips();
        if (part.dataset.part === 'tuning') refreshTuningAccessories();
      });
      part.querySelector('[data-variant]')?.addEventListener('change',()=>{
        updateTotal();
        if (part.dataset.part === 'exhaust') refreshTips();
        if (part.dataset.part === 'tuning') refreshTuningAccessories();
      });
    });

    if(sotfSwitch) sotfSwitch.addEventListener('change',updateTotal);
    if(sotfHarness) sotfHarness.addEventListener('change',updateTotal);
    if(sotfMount) sotfMount.addEventListener('change',updateTotal);

    section.querySelector('[data-reset]').addEventListener('click',()=>{
      panel.hidden = true;
      packagePanel.hidden = true;
      family = '';
      familyMakes = [];
      section.querySelectorAll('[data-family]').forEach(button=>button.setAttribute('aria-pressed','false'));
      fields.forEach((field,i)=>optionize(field,[],fieldKeys[i][0].toUpperCase()+fieldKeys[i].slice(1)));
      clearParts();
      vehicleStatus.textContent = 'Choose an engine family to start.';
    });

    addButton.addEventListener('click',async()=>{
      const items = parts.map(part=>{
        const variant = selectedVariant(part);
        if (!variant) return null;

        const item = {id:Number(variant.id),quantity:1};
        if (part.dataset.part === 'tuning') {
          const product = productById(part.querySelector('[data-product]').value);
          if (product?.requiresTuningForm) item.properties = {'Complete Tuning Form':TUNING_FORM_URL};
        }
        return item;
      }).filter(Boolean);

      const tuneProduct=productById(tuningPart?.querySelector('[data-product]')?.value);
      const tuneVariant=selectedVariant(tuningPart);
      const switchable=tuneProduct&&tuneVariant&&isSwitchableTune((tuneProduct.title||'')+' '+(tuneVariant.title||''));
      if(switchable&&sotfSwitch&&!sotfSwitch.disabled&&!sotfSwitch.value){
        cartStatus.textContent='Select the required SOTF switch for this tune option.';
        sotfSwitch.focus();
        return;
      }
      if(sotfSwitch?.value) items.push({id:Number(sotfSwitch.value),quantity:1});
      if(sotfHarness?.value) items.push({id:Number(sotfHarness.value),quantity:1});
      if(sotfMount?.value) items.push({id:Number(sotfMount.value),quantity:1});

      if (!items.length) return;
      addButton.disabled = true;
      cartStatus.textContent = 'Adding package to cart…';

      try {
        const response = await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        const body = await response.json();
        if (!response.ok) throw new Error(body?.description||'Could not add package.');
        cartStatus.textContent = 'Package added. Opening cart…';
        location.href = section.dataset.cartUrl || ((window.Shopify?.routes?.root||'/')+'cart');
      } catch (error) {
        cartStatus.textContent = error.message || 'Could not add package. Please try again.';
        updateTotal();
      }
    });

    load();
  };

  const run = () => document.querySelectorAll('.alpine-build-truck').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',run,{once:true}) : run();
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpine-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    const button = root.querySelector('[data-open-vehicle-menu]');
    if (!button || button.dataset.ready === 'true') return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      const menu = document.getElementById('alpine-vehicle-menu');
      if (!menu) return;
      menu.hidden = false;
      button.setAttribute('aria-expanded','true');
      menu.scrollIntoView({behavior:'smooth', block:'start'});
      window.setTimeout(() => {
        const year = menu.querySelector('[name="year"]');
        if (year && !year.disabled) year.focus({preventScroll:true});
      }, 450);
    });
  };
  const run = () => document.querySelectorAll('.section-alpine-photo-hero').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',run,{once:true}) : run();
  document.addEventListener('shopify:section:load',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpine-shop-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alpine-parts-search')) {
  customElements.define('alpine-parts-search', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.input = this.querySelector('input[name="q"]');
      this.panel = this.querySelector('[data-results]');
      this.list = this.querySelector('[data-result-list]');
      this.status = this.querySelector('[data-search-status]');
      if (!this.input || !this.panel || !this.list || !this.status) return;
      this.listeners = new AbortController();
      const signal = this.listeners.signal;
      this.sequence = 0;
      this.input.autocomplete = 'off';
      this.input.addEventListener('input', () => this.schedule(), {signal});
      this.input.addEventListener('focus', () => {
        if (this.list.children.length && this.input.value.trim() === this.lastQuery) this.panel.hidden = false;
      }, {signal});
      this.addEventListener('keydown', event => this.keydown(event), {signal});
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.panel.hidden = true;
      }, {signal});
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.listeners?.abort();
      this.listeners = null;
      this.sequence++;
    }
    schedule() {
      clearTimeout(this.timer);
      this.request?.abort();
      const sequence = ++this.sequence;
      const query = this.input.value.trim();
      this.panel.hidden = true;
      this.list.replaceChildren();
      this.status.textContent = '';
      if (query.length < 2) return;
      this.timer = setTimeout(() => this.lookup(query, sequence), 220);
    }
    async lookup(query, sequence) {
      const controller = new AbortController();
      this.request = controller;
      const timeout = setTimeout(() => controller.abort(), 5000);
      try {
        const endpoint = new URL(this.dataset.endpoint, location.origin);
        if (endpoint.origin !== location.origin) return;
        endpoint.pathname = endpoint.pathname.replace(/\.json$/, '') + '.json';
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '8');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
        const response = await fetch(endpoint, {signal:controller.signal, credentials:'same-origin', headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (sequence !== this.sequence || query !== this.input.value.trim() || !this.isConnected) return;
        const products = data.resources?.results?.products;
        if (!Array.isArray(products)) throw new Error('Invalid search response');
        const fragment = document.createDocumentFragment();
        for (const product of products.slice(0, 8)) {
          if (typeof product.url !== 'string' || typeof product.title !== 'string') continue;
          const url = new URL(product.url, location.origin);
          if (url.origin !== location.origin || !url.pathname.includes('/products/')) continue;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = url.pathname + url.search;
          const source = product.featured_image?.url || product.image;
          if (typeof source === 'string') {
            const imageUrl = new URL(source, location.origin);
            if (imageUrl.protocol === 'https:') {
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = '';
              image.width = 44;
              image.height = 44;
              image.loading = 'lazy';
              link.append(image);
            }
          }
          const title = document.createElement('span');
          title.textContent = product.title;
          link.append(title);
          item.append(link);
          fragment.append(item);
        }
        this.list.replaceChildren(fragment);
        this.lastQuery = query;
        const found = this.list.children.length > 0;
        this.status.textContent = found ? this.dataset.ready : this.dataset.empty;
        this.panel.hidden = !found || !this.contains(document.activeElement);
      } catch (error) {
        if (sequence === this.sequence && error.name !== 'AbortError') {
          this.panel.hidden = true;
          this.status.textContent = this.dataset.empty;
        }
      } finally {
        clearTimeout(timeout);
      }
    }
    keydown(event) {
      if (event.key === 'Escape') {
        this.panel.hidden = true;
        this.input.focus();
        this.panel.hidden = true;
        return;
      }
      if (this.panel.hidden) return;
      const links = [...this.list.querySelectorAll('a')];
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        links[Math.min(index + 1, links.length - 1)]?.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (index <= 0) this.input.focus();
        else links[index - 1].focus();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
